import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TaskItem from './TaskItem'
import withErrorBoundaryReturnNull from '../../../../../components/hocs/withErrorBoundaryReturnNull'

/**
 * @class TasksWrapper
 * @description Contains Tasks and maps individual tasks to Task Type
 */
class TasksWrapper extends Component {

  /**
   * @static propTypes
   */
  static propTypes = {
    tasks: PropTypes.array.isRequired,
    taskTypes: PropTypes.object.isRequired,
  }

  /**
   * @method render
   */
  render() {
    const { tasks, taskTypes } = this.props

    const mappedTasks = tasks.map(item => ({
      ...item,
      ...taskTypes[item.type]
    }))

    return (
      <div className="card shadow">
        <ul className="list-group">
          {mappedTasks.map(item => <TaskItem key={item._id} data={item} />)}
        </ul>
      </div>
    )
  }
}

export default withErrorBoundaryReturnNull(TasksWrapper)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Dashboard/components/Tasks/TasksWrapper.js